// Prefetch data on login
const Prefetch = store => {
  store.watch(
    state => store.getters['AUTH/isAuthenticated'],
    (value) => {
      if (value && store.getters.isCashRegisterInstalled) {
        if (store.getters.catalogSize === 0) {
          // FETCH_PRODUCTS now automatically fetches stocks when cash register is installed
          store.dispatch('FETCH_PRODUCTS')
        } else {
          // Catalog already loaded, just refresh stocks
          store.dispatch('FETCH_PRODUCT_STOCKS')
        }
      }
    }
  )
}

export default Prefetch
